var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnimalWelfare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Pets-Hospital--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Pets Hospital Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 11.84a0.25 0.25 0 0 0 -0.09 -0.3L21 9.62V7.75a0.26 0.26 0 0 0 -0.13 -0.22 0.25 0.25 0 0 0 -0.25 0l-0.16 0.09a7 7 0 0 0 -3.8 4.82 0.74 0.74 0 0 1 -0.72 0.55H8.75a2.17 2.17 0 0 0 -1 0.22A2.62 2.62 0 0 0 5.34 13a2.8 2.8 0 0 0 -1.58 1.6l-0.71 1.91a0.75 0.75 0 0 0 1.4 0.52l0.72 -1.9a1.24 1.24 0 0 1 0.72 -0.73 1.19 1.19 0 0 1 0.81 0 2.16 2.16 0 0 0 -0.2 0.91v1a1.75 1.75 0 0 1 -0.18 0.78l-0.58 1.16a2.2 2.2 0 0 0 -0.24 1v3.53a1.25 1.25 0 0 0 2.5 0v-2.2a1.8 1.8 0 0 1 0.51 -1.24l0.49 -0.49v0.47a2.5 2.5 0 0 0 0.13 1l1.5 3a1.28 1.28 0 0 0 1.68 0.56 1.25 1.25 0 0 0 0.56 -1.68l-1.27 -2.55c0.07 -0.22 0.22 -0.69 0.31 -0.95a0.25 0.25 0 0 1 0.23 -0.17h3.65a0.25 0.25 0 0 1 0.25 0.23l0.35 4.15a1.32 1.32 0 0 0 2.61 -0.16V22c0 -3.87 0 -5 1.83 -8.38a0.25 0.25 0 0 1 0.22 -0.13h1.2a1.42 1.42 0 0 0 1.34 -0.61Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 9.5a0.5 0.5 0 0 0 0.5 0.5h2.5a0.5 0.5 0 0 0 0.5 -0.5V7A0.25 0.25 0 0 1 7 6.75h2.5a0.5 0.5 0 0 0 0.5 -0.5v-2.5a0.5 0.5 0 0 0 -0.5 -0.5H7A0.25 0.25 0 0 1 6.75 3V0.5a0.5 0.5 0 0 0 -0.5 -0.5h-2.5a0.5 0.5 0 0 0 -0.5 0.5V3a0.25 0.25 0 0 1 -0.25 0.25H0.5a0.5 0.5 0 0 0 -0.5 0.5v2.5a0.5 0.5 0 0 0 0.5 0.5H3a0.25 0.25 0 0 1 0.25 0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnimalWelfare);
export default ForwardRef;